let careTrigger = document.querySelectorAll('.js-product-care-trigger');

careTrigger = Array.from(careTrigger);

careTrigger.forEach((trigger) => {

  trigger.addEventListener('click', (event) => {
    console.log('care');

    document.querySelector('body').classList.add('inactive');
    document.querySelector('#shopify-section-header').classList.add('inactive');

    document.querySelector('.js-product-care-module').classList.add('active');
  });

});

if(document.querySelector('.js-product-care-module-closer')) {
  document.querySelector('.js-product-care-module-closer').addEventListener('click', (event) => {
    document.querySelector('body').classList.remove('inactive');
    document.querySelector('#shopify-section-header').classList.remove('inactive');
    document.querySelector('.js-product-care-module').classList.remove('active');
  });
}
